import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";
import { DATE_FORMAT, MIME_TYPE } from '../../../constants/constants';
import { DocumentPreview } from '../../viewDocument/DocumentPreview';
import { LoadingUtil } from '../../../util/LoadingUtil';
import { EnvConstants } from '../../../EnvConstants';
import { DonwloadUtil } from '../../../util/DonwloadUtil';
import { UserUtil } from '../../../util/UserUtil';
import { PAGE_MODE } from "../../../constants/constants";
import { SELECTION_TYPE } from '../../../framework/grid/GridFw';
import { GenerarCadenaModal } from '../../solicitudes-asignadas/modals/GenerarCadenaModal';
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { RequestUtil } from '../../../util/RequestUtil';
import { MessageUtil } from '../../../util/MessageUtil';

export class SolicitudesEjecutadasDetailPage extends BasePage {

  createPageProperties = (pageApi) => {
    return {
      title: 'CADENAS GENERADAS',
      icon: 'none',
    };
  }

  renderPage(pageApi) {
    const getlistcadenaGrid = () => pageApi.getComponent('grid');
    const getlistcadenaForm = () => pageApi.getComponent('form');

    const DocumentPreviewModal = (data) => {
      return {
        width: 950,
        maskClosable: true,
        closable: false,
        component: <DocumentPreview name={data} getParentApi={pageApi.getApi} />
      }
    };

    const formlistcadenaConfig = {
      layout: 'vertical',
      title: 'Filtro de Búsqueda',
      load: {
        validation: () => pageApi.getParamId() != null,
        queryId: 870,
        params: { id_doc: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
        fnOk: async () => {
          const reqParams = LoadUtil.getReqParams({
            queryId: 870,
            params: { id_doc: pageApi.getParamId() },
          });

          const resp = await RequestUtil
            .postData(EnvConstants.GET_URL_READ(), reqParams)
            .then(r => r.dataObject)
            .catch(() => null);

          let values = getlistcadenaForm().getData();
          values = { ...values, detalle: resp.detalle }
          getlistcadenaForm().setData(values)
        }
      },
      fields: [
        { name: 'detalle', label: '', column: 12, readOnly: true },
        { name: 'nroIA', label: 'Nro.IA:', column: 3 },
        { name: 'cadena', label: 'Nro.Cadena:', column: 3 },
        { type: "select", name: "matriz", label: "Matriz", column: 6, load: { queryId: 487, params: { id_doc: pageApi.getParamId() } }, search: true, },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW)
          formApi.load();
      }
    }

    const gridlistcadenaConfig = {
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      selection: { type: SELECTION_TYPE.MULTIPLE },
      load: {
        queryId: 916,
        params: {
          id_user: UserUtil.getUserId(), ID_SOLICITUD_SERVICIO: pageApi.getParamId()
        },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        // { name: 'nro_ia', label: 'Nro IA' },
        { name: 'NRO_CC', label: 'Codigo Cadena' },
        { name: 'NOMBRE_CADENA', label: 'Tipo Cadena' },
        { name: 'MATRIZ', label: 'Matriz' },
        {
          type: "date",
          name: "FECHA_CREACION",
          label: "F.Registro",
          format: DATE_FORMAT.DDMMYYYY,
        },
        { name: 'estado', label: 'Estado' },
        { name: 'fecha_firmado_supervisor', label: 'Fecha Aprobación Ins.' },
        { name: 'fecha_firmado_cliente', label: 'Fecha Aprobación Cli.' },
        { name: 'cliente_aprobador', label: 'Cliente Aprobador' },
        {
          type: "button", icon: <span style={{ fontWeight: 500 }}>Ver Resultados</span>, label: 'Opciones', colSpan: 6, title: 'Detalle Cadena', color: 'blue',
          link: (value, row, index) => `/solicitudes-ejecutadas/solicitudes-ejecutadas/resultados/${row.ID_CADENA}`,
        },
        {
          ...COLUMN_DEFAULT.PDF, title: 'Visualizar Cadena', color: 'black', colSpan: 0, onClick: (value, row, index) => {
            LoadingUtil.loadShow();
            let url = EnvConstants.GET_REPORT2_URL() + 'List_Cadena_MA';
            DonwloadUtil.donwloadBlob(url, { params: { ID_CADENA: row.ID_CADENA } }, "Cadena_" + row.nro_ia + ".pdf").then(x => {

              var reader = new FileReader();
              reader.readAsDataURL(x.blob);
              reader.onloadend = function () {
                var base64data = reader.result;
                let obj = {
                  url: base64data,
                  type_file: MIME_TYPE.pdf
                }
                pageApi.showModal(DocumentPreviewModal(obj));
                LoadingUtil.loadHide();
              }
            }).catch(x => {
              console.error(x)
              LoadingUtil.loadHide();
            });
          },
        },
      ]
    };

    const ListaCadenaConfig = {
      events: {

      }
    }

    const GenerarCadenaModalConfig = (data) => {
      return {
        width: 650,
        maskClosable: false,
        closable: true,
        background: 'white',
        component: <GenerarCadenaModal name={data} getParentApi={pageApi.getApi} config={ListaCadenaConfig} />
      }
    };

    const barButtonlistcadenaconfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SEARCH, onClick: () => getlistcadenaGrid().load({
            params: {
              ...getlistcadenaForm().getData(),
              nroIA: getlistcadenaForm()?.getData()?.nroIA || null,
              cadena: getlistcadenaForm()?.getData()?.cadena || null,
              matriz: getlistcadenaForm()?.getData()?.matriz || null,
            }
          })
        },
        { ...BUTTON_DEFAULT.RETURN, label: "Regresar", link: "/solicitudes-ejecutadas/solicitudes-ejecutadas-admin", },
        {
          ...BUTTON_DEFAULT.EXECUTE, label: "Aprobar", onClick: () => {
            const arrCadena = Array.from(getlistcadenaGrid()?.getSelectedItem(), el => el.ID_CADENA);

            LoadUtil.loadByQueryId({
              url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
              queryId: 887,
              reqParams: {
                params: {
                  cadenas: JSON.stringify(arrCadena),
                  firma_cliente: true,
                  id_usuario: UserUtil.getUserId(),
                },
              },
              fnOk: (resp) => {
                if (!resp.error) {
                  MessageUtil("success", resp.message, "");
                } else {
                  MessageUtil("warning", resp.error, "");
                }

                getlistcadenaGrid().load();
              },
            });
          }
        }
      ]
    }


    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formlistcadenaConfig}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonlistcadenaconfig}
        />
        <GridFw
          name="grid"
          getParentApi={pageApi.getApi}
          config={gridlistcadenaConfig}
        />
      </>
    )
  }
}
